module.exports = __webpack_public_path__ + "videos/freehand-cn.72cd4c1.mp4";